import { render, staticRenderFns } from "./SashReinforcement.vue?vue&type=template&id=0b3e9d5c&scoped=true&"
import script from "./SashReinforcement.vue?vue&type=script&lang=js&"
export * from "./SashReinforcement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e9d5c",
  null
  
)

export default component.exports